import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  role_permissions: [],
};

const getters = {
  allRolePermissions: (state) => state.role_permissions,
};

const actions = {
  async fetchRolePermissions({ commit }, params = {}) {
    try {
      commit("resetRolePermissions");
      const response = await axios.get("/role-permissions", {
        params: prm(params),
      });
      commit("setRolePermissions", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch role_permissions:", error);
      if (error.status == 404) {
        commit("setRolePermissions", { data: [] });
        return { data: [] };
      }
    }
  },
  async createRolePermission({ commit }, role_permission) {
    console.log("role_permission", role_permission);
    try {
      const response = await axios.post("/role-permissions", role_permission);
      commit("addRolePermission", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create role_permission:", error);
      throw error;
    }
  },
  async fetchRolePermissionById(_, id) {
    try {
      const response = await axios.get(`/role-permissions/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch role_permission:", error);
      throw error;
    }
  },
  async updateRolePermission({ commit }, role_permission) {
    try {
      const response = await axios.put(
        `/role-permissions/${role_permission.id}`,
        role_permission
      );
      commit("updateRolePermission", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update role_permission:", error);
      throw error;
    }
  },
  async closeRolePermission({ commit }, role_permission) {
    try {
      const response = await axios.post(`/role-permissions/close`, role_permission);
      commit("closeRolePermission", response.data);
    } catch (error) {
      console.error("Failed to close role_permission:", error);
      throw error;
    }
  },
  async deleteRolePermissionById({ commit }, id) {
    try {
      const response = await axios.delete(`/role-permissions/${id}`);
      commit("removeRolePermission", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete role_permission:", error);
      throw error;
    }
  },
};

const mutations = {
  setRolePermissions(state, role_permissions) {
    state.role_permissions = role_permissions.data; // Ensure this matches your API's response structure
  },
  addRolePermission(state, role_permission) {
    state.role_permissions.push(role_permission);
  },
  updateRolePermission(state, updatedRolePermission) {
    const index = state.role_permissions.findIndex(
      (role_permission) => role_permission.id === updatedRolePermission.id
    );
    if (index !== -1) {
      state.role_permissions.splice(index, 1, updatedRolePermission);
    }
  },
  closeRolePermission(state, closedRolePermission) {
    const index = state.role_permissions.findIndex(
      (role_permission) => role_permission.id === closedRolePermission.id
    );
    if (index !== -1) {
      state.role_permissions.splice(index, 1, closedRolePermission);
    }
  },
  removeRolePermission(state, id) {
    state.role_permissions = state.role_permissions.filter(
      (role_permission) => role_permission.id !== id
    );
  },
  resetRolePermissions(state) {
    state.role_permissions = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
